<template>
    <div>
        <TopBar/>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <Breadcrumbs v-if="init" :nominative="nominative" :device="device"/>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="alert alert-success" role="alert">
                        <h4 v-if="init" class="text-center font-weight-bolder pt-3 pb-2">
                            {{ fullAddress }}
                        </h4>
                    </div>
                </div>
            </div>
            <div class="row mb-5">
                <div class="col-12 col-md-6">
                    <div class="row">
                        <div class="col-12">
                            <DevData :devStat="deviceStat"/>
                        </div>
                        <div class="col-12 mb-4 mb-lg-0">
                            <div class="alert alert-info" role="alert">
                                <Messengers :device="device"
                                            :icons-lg="true"
                                            title="Отримуйте актуальні показники датчиків у ваш месенджер"
                                            class="py-3"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <Aqi :last24HoursStat="deviceStat" :devEUI="$route.query.deveui" />
                    <MapMini v-if="init"
                             :initialLon="device.latitude"
                             :initialLat="device.longitude"
                             :initialZoom="11"
                             :countryBorder="false"/>
                </div>
            </div>
            <div class="row mb-5">
                <div class="col-12">
                    <LocalityChart :device="device" :data="deviceStat"/>
                </div>
            </div>
        </div>
        <Footer/>
        <Modal/>
    </div>
</template>

<script>

import TopBar from "../components/TopBar";
import Footer from "../components/Footer";
import Modal from "../components/Modal";
import MapMini from "../components/MapMini";
import DevData from "../components/DevData";
import LocalityChart from "../components/LocalityChart";
import moment from "moment-mini";
import DeviceService from "../services/DeviceService";
import StatService from "@/services/StatService";
import NominatimService from "../services/NominatimService";
import Messengers from "../components/Messengers";
import EventBus from "../components/EventBus";
import Breadcrumbs from "../components/Breadcrumbs";
import Aqi from "@/components/Aqi";

export default {
    name: "Locality",
    components: {
        TopBar,
        Footer,
        Modal,
        MapMini,
        DevData,
        LocalityChart,
        Messengers,
        Breadcrumbs,
        Aqi
    },
    data() {
        return {
            init: false,
            deviceStat: [],
            device: null,
            nominative: null
        }
    },
    methods: {
        async loadChartData(deveui, start, stop) {
            const statService = new StatService();
            const deviceService = new DeviceService();

            const device = await deviceService.getDevice(deveui);
            const deviceStat = await statService.getDeviceStat(deveui, start, stop);

            if (device && deviceStat) {
                this.deviceStat = deviceStat;
                this.device = device;
            } else {
                await this.$router.replace("/404");
            }
        },
        async loadNominative() {
            this.nominative = await (new NominatimService()).getInfo(this.device?.latitude, this.device?.longitude);
        }
    },
    computed: {
        fullAddress() {
            return this.device?.name || this.nominative?.address.country + ", "
                + this.nominative?.address.state + ", "
                + this.nominative?.address.town + ", "
                + this.nominative?.address.road + " "
                + (this.nominative?.address?.house_number || "");
        }
    },
    async mounted() {
        if (this.$route.query.deveui) {

            await this.loadChartData(
                this.$route.query.deveui,
                moment().format("YYYY-MM-DD"),
                moment().subtract(1, 'days').format("YYYY-MM-DD")
            );
            await this.loadNominative();

            this.init = true;

            setTimeout(() => {
                EventBus.$emit("PRELOADER_HIDE");
            }, 300);

            document.title = "Розумне місто - " + this.device?.name;
        }

        EventBus.$on("DP_CHANGE", async ({start, stop}) => {
            EventBus.$emit("PRELOADER_SHOW");
            await this.loadChartData(this.$route.query.deveui, start, stop);
            setTimeout(() => {
                EventBus.$emit("PRELOADER_HIDE");
            }, 200);
        });
    }
}
</script>

<style lang="less" scoped>
.container {
    min-height: 90vh;
}
</style>